import * as React from 'react'

import { IItemCard } from '../interface'

import ItemCardContentCommonWrapper from '../itemCardContentCommonWrapper'
import LockupAttributes from '../lockupAttributes'
import LockupFilesIncluded from '../lockupFilesIncluded'

const ItemCardContentWithAttributesAndFiles = (props: IItemCard) => {
  return (
    <ItemCardContentCommonWrapper {...props}>
      <LockupAttributes {...props} />
      <LockupFilesIncluded {...props} />
    </ItemCardContentCommonWrapper>
  )
}

export default ItemCardContentWithAttributesAndFiles
